import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userToken: "",
  email: "",
  forceReset: false,
  globysId: "",
  error: "",
  userNotInFirestore: false,
  userLoggedInSuccess: false,
  envFlags: [],
  paymentWarning: {},
  paymentAmounts: [],
  bannerMessages: [],
  routerCodes: [],
  publicKey: "",
  cbstKey: "",
  cbstKey2: "",
};

const UserInfoSlice = createSlice({
  name: "UserInfo",
  initialState,
  reducers: {
    userInfo: (state, action) => {
      state.userToken = action.payload.userToken;
      state.email = action.payload.email;
    },
    setForceReset: (state, action) => {
      state.forceReset = action.payload;
    },
    setGlobysId: (state, action) => {
      state.globysId = action.payload;
    },
    setUserError: (state, action) => {
      state.error = action.payload;
    },
    setUserNotInFirestore: (state, action) => {
      state.userNotInFirestore = action.payload;
    },
    setUserLoggedInSuccess: (state, action) => {
      state.userLoggedInSuccess = action.payload;
    },
    setEnvFlags: (state, action) => {
      state.envFlags = action.payload;
    },
    paymentWarningMessage: (state, action) => {
      state.paymentWarning = action.payload;
    },
    setPaymentAmounts: (state, action) => {
      state.paymentAmounts = action.payload;
    },
    setBannerMessages: (state, action) => {
      state.bannerMessages = action.payload;
    },
    setRouterCodes: (state, action) => {
      state.routerCodes = action.payload;
    },
    setPublicKey: (state, action) => {
      state.publicKey = action.payload;
    },
    setCbstKey: (state, action) => {
      state.cbstKey = action.payload;
    },
    setCbstKey2: (state, action) => {
      state.cbstKey2 = action.payload;
    },
  },
});

export const {
  userInfo,
  setForceReset,
  setGlobysId,
  setUserError,
  setUserNotInFirestore,
  setEnvFlags,
  setUserLoggedInSuccess,
  paymentWarningMessage,
  setPaymentAmounts,
  setBannerMessages,
  setRouterCodes,
  setPublicKey,
  setCbstKey,
  setCbstKey2,
} = UserInfoSlice.actions;
export const userInfoReducer = UserInfoSlice.reducer;
